import Flex from '@creditflowresearch/uilib/Flex';
import type { ToggleButtonGroupTheme } from '@creditflowresearch/uilib/ToggleButtonGroup';
import ButtonGroup from '@/creditflowresearch/ui/common/components/organisms/ButtonGroup';
import type { IFilterButton } from '@/creditflowresearch/ui/common/components/organisms/ButtonGroup';
import { IFilterButtonSet } from '@/creditflowresearch/ui/common/hooks/filters/useFilterButtons';

interface IFilterSetGroupProps {
  filterSets: IFilterButtonSet[],
  onClick?: (item: IFilterButton) => void,
  theme?: ToggleButtonGroupTheme,
}

const FilterSetGroup = ({ filterSets, onClick, theme }: IFilterSetGroupProps) => {
  if (filterSets.length === 0) {
    return null;
  }

  return (
    <Flex align="center" wrap="wrap-reverse" direction="row" gap={ 30 }>
      { filterSets.map((set) => (
        <ButtonGroup
          key={ set.key }
          items={ set.items }
          onClick={ onClick }
          theme={ theme }
          ariaLabel={ set.key }
        />
      )) }
    </Flex>
  );
};

export default FilterSetGroup;
